var getParameterByName = function (e) {
	var name = e.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
	var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"), results = regex.exec(location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

var filter = {

	useHistory: true,

	init: function () {
		filter.ajax.init();
		filter.range();
	},

	ajax: {

		request: null,

		init: function () {

			// select/input
			$('.m-filter select:not(.js-filter-ajax-done),.m-filter input:not(.js-filter-ajax-done)').each(function () {
				var input = $(this);
				var wrapper = input.closest('.m-refine');
				var form = input.closest('form');

				// change
				input.on('change', function () {
					// reset page
					form.find('input[name="page"]').val(1);
					// submit form
					filter.ajax.update(form, false);
					return false;
				});

				// done
				wrapper.addClass('js-filter-ajax-done');
			});

			// form
			$('form:not(.js-filter-form-done)').has('.m-filter').each(function () {
				var form = $(this);

				// submit
				form.on('submit', function () {
					filter.ajax.update(form, false);
					return false;
				});

				// done
				form.addClass('js-filter-form-done');
			});

			// sort/pager
			$('.m-refine:not(.js-filter-sort-done)').each(function () {
				var wrapper = $(this);
				var sort = $(wrapper.attr('data-sort')).find('[name="sort"]');
				var pager = $(wrapper.attr('data-pager')).find('.js-link:not(.disabled)');
				var form = $(wrapper.attr('data-filters')).closest('form');

				// sort
				sort.on('change', function () {
					// reset page
					form.find('input[name="page"]').val(1);
					// set sort
					form.find('[name="sort"]').val($(this).val());
					// submit form
					filter.ajax.update(form, true);
					return false;
				});

				// pager
				pager.off('click').on('click', function () {
					// set page
					form.find('[name="page"]').val($(this).attr('data-page'));
					// submit form
					filter.ajax.update(form, true);
					return false;
				});

				// done
				wrapper.addClass('js-filter-sort-done');
			});

		},

		update: function (form, scroll) {
			// products/filters
			var productsReplace = $('#jsRefineProducts');
			var filtersReplace = $('#jsRefineFilters');

			//pager
			var pagerReplace = $('#jsRefinePagerReplaceTop,#jsRefinePagerReplaceBottom');
			var pagerGroup = $('#jsRefinePagerTop,#jsRefinePagerBottom');

			// count
			var countReplace = $('#jsRefineTotalResults');
			var countReplaceMultiple = $('#jsRefineTotalResultsMultiple');

			// templates
			var productsTemplate = $('#categoryProductsTemplate');
			var pagerTemplate = $('#pagerTemplate');

			// previous request
			if (filter.ajax.request !== null) {
				filter.ajax.request.abort();
				filter.ajax.request = null;
			}

			// show loader
			popups.loader();

			// scroll
			if (scroll) {
				site.scrollTo($('#category-top').offset().top);
			}

			// hide products
			productsReplace.hide();

			// hide pager
			pagerGroup.hide();

			// get fields
			var fields = form.find('input:visible, input[type="hidden"], select:visible');

			// get grid
			var grid = productsReplace.closest('.m-grid');

			// ajax
			filter.ajax.request = $.ajax({
				url: form.attr('data-json-url'),
				data: fields.serialize(),
				cache: false,
				success: function (data) {

					if (Modernizr.history && filter.useHistory) {
						history.replaceState(null, null, '?' + fields.serialize());
					}

					// remove previous error
					grid.prev('.form-error:first').remove();

					// get product template
					var aTmp = productsTemplate.html();
					aTmp = Hogan.compile(aTmp);

					// replace products
					productsReplace.html(aTmp.render(data.Products));

					var filters = '';

					// get filters
					for (var i = 0; i < data.Filters.length; i++) {
						var f = data.Filters[i];
						var bTmp = $('#facet' + f.Template + 'Template').html();
						bTmp = Hogan.compile(bTmp);
						filters += bTmp.render(f);
					}

					// replace filters
					filtersReplace.html(filters);

					// replace pager
					var cTmp = pagerTemplate.html();
					cTmp = Hogan.compile(cTmp);
					pagerReplace.html(cTmp.render(data.Pager));

					// update count
					countReplace.text(data.Products.TotalResults);

					// add result(s)
					if (parseInt(data.Products.TotalResults, 10) > 1 || parseInt(data.Products.TotalResults, 10) == 0) {
						countReplaceMultiple.show();
					}
					else {
						countReplaceMultiple.hide();
					}

				},
				error: function () {
					if (status === "abort") return;
					// remove previous error
					grid.prev('.form-error:first').remove();
					// show new error
					grid.before('<p class="form-error">Sorry, there was an error when filtering. Please try again.</p>');
				},
				complete: function () {
					// clear request
					filter.ajax.request = null;
					// hide loader
					popups.loader(true);
					// show products
					productsReplace.show();
					// show pager
					pagerGroup.show();
				}
			});

		}

	},

	range: function () {

		$('.m-filter__range:not(.js-range-done)').each(function () {
			var wrapper = $(this);
			var form = wrapper.closest('form');
			var f = wrapper.closest('.m-filter');
			inputFrom = wrapper.find('.js-from');
			inputTo = wrapper.find('.js-to');

			// min/max
			var min = parseInt(f.attr('data-min'), 10);
			var start = min;
			if (parseInt(inputFrom.val(), 10) != min) {
				start = parseInt(inputFrom.val(), 10);
			}
			var max = parseInt(f.attr('data-max'), 10);
			var end = max;
			if (parseInt(inputTo.val(), 10) != max) {
				end = parseInt(inputTo.val(), 10);
			}

			// step
			step = parseInt(f.attr('data-step'), 10) || 1;

			// set change
			if (inputFrom.val() != min || inputTo.val() != max) {
				wrapper.attr('data-changed', 'True');
			}

			// add slider markup
			wrapper.prepend('<div class="m-filter__range__slider"><div class="m-filter__range__slider__inner js-slider" /></div>');

			// init slider
			var slider = wrapper.find('.js-slider').slider({
				range: true,
				min: min,
				max: max,
				values: [start, end],
				step: step,
				slide: function (e, details) {
					var v = details.values;
					inputFrom.val(v[0]);
					inputTo.val(v[1]);
				},
				stop: function (e, details) {
					// changed
					wrapper.attr('data-changed', 'True');
					// update
					filter.ajax.update(form, false);
				}
			});

			// init inputs
			inputFrom.add(inputTo).on('change', function () {
				var _min = Math.round(inputFrom.val());
				var _max = Math.round(inputTo.val());

				// changed
				wrapper.attr('data-changed', 'True');

				// set min
				if (_min < min || isNaN(_min) || _min > _max) { // less than min, not a number, greater than max
					_min = min;
				}
				inputFrom.val(_min);

				// set max
				if (_max > max || isNaN(_max) || _max < _min) { // greater than max, not a number, less than min
					_max = max;
				}
				inputTo.val(_max);

				// set slider values
				slider.slider('values', [_min, _max]);
			});

			// done
			wrapper.addClass('js-range-done');
		});

	}

};

$(function () {
	filter.init();
	site.doc.ajaxComplete(function () {
		filter.init();
	});
});